var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14.6673C4.31802 14.6673 1.33325 11.6825 1.33325 8.00065C1.33325 4.31875 4.31802 1.33398 7.99992 1.33398C11.6818 1.33398 14.6666 4.31875 14.6666 8.00065C14.6666 11.6825 11.6818 14.6673 7.99992 14.6673ZM7.99992 13.334C10.9455 13.334 13.3333 10.9462 13.3333 8.00065C13.3333 5.05513 10.9455 2.66732 7.99992 2.66732C5.0544 2.66732 2.66659 5.05513 2.66659 8.00065C2.66659 10.9462 5.0544 13.334 7.99992 13.334ZM7.33325 4.66732H8.66658V6.00065H7.33325V4.66732ZM7.33325 7.33398H8.66658V11.334H7.33325V7.33398Z",
    fill: "#BD8F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b39fa2dc7bbcfab9875ea1e7569eb977.svg";
export { ForwardRef as ReactComponent };